// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3d774643","703":"c0bc73db"}[chunkId] + ".chunk.js";
};